<template>
  <div v-if="showMenu" class="multi-block-burger-menu">
    <li v-if="isShowArchivedFlags" v-on:click="toggleArchFlags()">
      <i class="fa fa-eye" aria-hidden="true"></i>
        Show archived flags
    </li>
    <li v-else @click.prevent="toggleArchFlags()">
      <i class="fa fa-eye-slash" aria-hidden="true"></i>
        Hide archived flags
    </li>
    <li class="separator"></li>
    <template v-if="allowMultiAction">
      <li v-on:click="deleteBlocks()">
        <i class="fa fa-trash" aria-hidden="true"></i>
        Delete {{ selectedBlocksCount }} blocks
      </li>
    </template>
    <template v-else>
      <li class="disabled">
        <i class="fa fa-trash" aria-hidden="true"></i>
        Delete (max. 20 blocks)
      </li>
    </template>
    <template v-if="allowMultiJoin">
      <li v-if="hasLockInSelection">
        <i class="fa menu-preloader"></i>
        Join {{ selectedBlocksCount }} blocks
      </li>
      <li v-on:click="joinBlocks()" v-else>
        <i class="-re-join" aria-hidden="true"></i>
        Join {{ selectedBlocksCount }} blocks
      </li>
    </template>
    <template v-else>
      <li class="disabled">
        <i class="-re-join" aria-hidden="true"></i>
        Join (max. 20 unvoiced blocks)
      </li>
    </template>
    <li class="separator"></li>
    <li @click.stop="() => {return false}">
      <i class="fa fa-language" aria-hidden="true"></i>
      Language: 
      <select v-model="selectedLanguage" v-on:change="setLanguage">
        <option></option>
        <option v-for="(val, key) in languages" :value="key">{{ val }}</option>
      </select>
    </li>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';

  import { Languages } from "../../../mixins/lang_config.js"
  import DeleteBlockWarning from './DeleteBlockWarning.vue';
  import JoinBlocksWarning from './JoinBlocksWarning.vue';

  import v_modal from 'vue-js-modal';
  
  Vue.use(v_modal, { dialog: true });

  export default {
    data() {
      return {
        languages: Languages,
        selectedLanguage: ''
      }
    },
    props: ['isHideArchFlags', 'block'],
    computed: {
      showMenu: {
        get() {
          return this.isMultiBlocksSelected && this.isBlockSelected(this.block.blockid);
        },
        cache: false
      },
      selectedBlocksCount: {
        get() {
          return this.selectedBlocks.length;
        },
        cache: false
      },
      allowMultiAction: {
        get() {
          return this.selectedBlocksCount <= 20;
        },
        cache: false
      },
      allowMultiJoin: {
        get() {
          if (!this.allowMultiAction) {
            return false;
          }
          if (this.selectedBlocksCount > 2) {
            let voiced = this.selectedBlocks.find(blockId => {
              const block = this.storeList.get(blockId);
              return block.audiosrc && block.audiosrc.length > 0;
            });
            if (voiced) {
              return false;
            }
          }
          return true;
        },
        cache: false
      },
      hasLockInSelection: {
        get() {
          let locked = this.selectedBlocks.find(blockId => {
            return this.isBlockLocked(blockId);
          });
          return locked ? true : false;
        },
        cache: false
      },
      isShowArchivedFlags: {
        get() {
          return this.selectedBlocks.find(blockId => {
            const block = this.storeList.get(blockId);
            return block.isHideArchFlags;
          }) ? true : false;
        },
        cache: false
      },
      ...mapGetters(['blockSelection', 'isMultiBlocksSelected', 'isBlockSelected', 'selectedBlocks', 'isBlockLocked', 'storeList', 'storeListO', 'audioTasksQueueBlock', 'currentBookMeta']),
      ...mapGetters('blocksModule', ['massSetLanguageProcess'])
    },
    mounted() {
      this.collecSelectedLanguage();
    },
    methods: {
      setLanguage() {
        this.$parent.close();
        return this.massSetLanguage([this.selectedLanguage]);
      },
      collecSelectedLanguage() {
        this.selectedLanguage = '';
        if (this.showMenu) {
          let langsList = [];
          this.selectedBlocks.forEach(blockId => {
            const block = this.storeList.get(blockId);
            if (!langsList.includes(block.language)) {
              langsList.push(block.language);
            }
          });
          if (langsList.length > 1) {
            this.selectedLanguage = '';
          } else if (langsList.length === 1) {
            this.selectedLanguage = langsList[0];
          }
        }
      },
      joinBlocks() {
        if (!this.allowMultiAction) {
          return false;
        }
        let typeDiffers = this.selectedBlocks.find(blockId => {
          const firstBlock = this.storeList.get(blockId);
          return this.selectedBlocks.find(_blockId => {
            const secondBlock = this.storeList.get(_blockId);
            return firstBlock.type !== secondBlock.type;
          });
        });
        if (typeDiffers) {
          this.$root.$emit('join_type_differs');
          return false;
        }
        let voiceworkDiffers = this.selectedBlocks.find(blockId => {
          const firstBlock = this.storeList.get(blockId);
          return this.selectedBlocks.find(_blockId => {
            const secondBlock = this.storeList.get(_blockId);
            return firstBlock.voicework !== secondBlock.voicework;
          });
        });
        if (voiceworkDiffers) {
          this.$root.$emit('join_voicework_differs');
          return false;
        }
        let hasChanges = this.selectedBlocks.find(blockId => {
          const block = this.storeList.get(blockId);
          return block.getIsChanged() || block.hasChangedPart() || block.isAudioChanged;
        });
        if (hasChanges) {
          this.$root.$emit('join_has_changes');
          return false;
        }
        let adaptDiffers = this.selectedBlocks.find(blockId => {
          const firstBlock = this.storeList.get(blockId);
          return this.selectedBlocks.find(_blockId => {
            const secondBlock = this.storeList.get(_blockId);
            return (firstBlock.adapted || secondBlock.adapted) && firstBlock.adapted !== secondBlock.adapted;
          });
        });
        if (adaptDiffers) {
          this.$root.$emit('join_adapted_differs', this.currentBookMeta && this.currentBookMeta.copy_type === "adapted");
          return false;
        }
        let joinInfo = {};
        this.$modal.show(JoinBlocksWarning, {
          joinInfo: joinInfo,
          join_count: this.selectedBlocksCount
        },
        {
          height: 'auto',
          width: '460px',
          clickToClose: false
        },
        {
          'closed': (e) => {
            if (joinInfo && joinInfo.success) {
              this.checkAudioEditing();
              return this.massJoin([[], joinInfo.line_breaks])
                .then(() => {
                  this.$root.$emit('for-bookedit:scroll-to-block', this.selectedBlocks[0]);
                  return Promise.resolve(true);
                });
            } else {
              return Promise.resolve(false);
            }
          }
        });
      },
      deleteBlocks() {
        if (!this.allowMultiAction) {
          return false;
        }
        let deleteInfo = {};
        this.$modal.show(DeleteBlockWarning, {
          deleteInfo: deleteInfo,
          delete_count: this.selectedBlocksCount
        },
        {
          height: 'auto',
          width: '440px',
          clickToClose: false
        },
        {
          'closed': (e) => {
            if (deleteInfo && deleteInfo.success) {
              this.checkAudioEditing();
              return this.massDelete()
                .then(() => {
                  return Promise.resolve(true);
                });
            } else {
              return Promise.resolve(false);
            }
          }
        });
      },
      toggleArchFlags() {
        if (!this.isShowArchivedFlags) {
          this.selectedBlocks.filter(blockId => {
            const block = this.storeList.get(blockId);
            return !block.isHideArchFlags;
          }).forEach(blockId => {
            const block = this.storeList.get(blockId);
            block.set_isHideArchFlags(true);
          });
        } else {
          this.selectedBlocks.filter(blockId => {
            const block = this.storeList.get(blockId);
            return block.isHideArchFlags;
          }).forEach(blockId => {
            const block = this.storeList.get(blockId);
            block.set_isHideArchFlags(false);
          });
        }
      },
      checkAudioEditing() {
        let editingBlock = this.audioTasksQueueBlock();
        if (editingBlock && editingBlock.blockid) {
          let block = this.selectedBlocks.find(blockId => {
            return blockId === editingBlock.blockid;
          });
          if (block) {
            this.$root.$emit('for-audioeditor:force-close');
          }
        }
      },
      ...mapActions('blocksModule', ['massSetLanguage', 'massDelete', 'massJoin'])
    },
    watch: {
      'blockSelection': {
        handler(val) {
          this.collecSelectedLanguage();
        },
        deep: true
      },
      'massSetLanguageProcess': {
        handler(val) {
          if (!val) {
            this.collecSelectedLanguage();
          }
        }
      }
    }
  }
</script>
<style lang="less">
  .multi-block-burger-menu {
    .-re-join {
      background: url(/static/mass-join.png);
      background-size: 14px;
      width: 14px;
      height: 14px;
      display: inline-block;
    }
    li.disabled {
      color: #A8A9AB;
      i {
        color: #A8A9AB;
      }
      .-re-join {
        background: url(/static/mass-join-disabled.png);
        background-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/books/block/BlockBurgerMenu.vue